<template>
  <v-app :dark="dark">
    
    <confirm ref="confirm"></confirm>
    <v-main color="primary" :dark="dark">
      <router-view> </router-view>
    </v-main>
  </v-app>
</template>
<script>
import Confirm from "./components/Confirm";
import { mapActions, mapGetters } from "vuex";

export default {
  props:['banner'],
  metaInfos() {
      if (this.host) return {
        title: `☑ Officiële website ${this.host.name}`,
        meta: [
            { property: 'og:title', content: this.host.feature ? this.host.feature.title :  this.host.name},
            { property: 'og:site_name', content: this.host.name},
            {property: 'og:type', content: 'website'},    
            {name: 'robots', content: 'index,follow'} ,
            { name: 'description', content: this.host.feature ? this.host.feature.description :  this.host.description}
          ]
      }
      if (this.feauture) return {
        title: `${this.feauture.url}`,
        meta: [
            { property: 'og:title', content: this.feauture.url},
            { property: 'og:site_name', content: this.feauture.url},
            {property: 'og:type', content: 'website'},    
            {name: 'robots', content: 'index,follow'} ,
            { name: 'description', content: this.feauture.url}
          ]
      }
      return this.$config.meta
   },
components: {
    Confirm
  },
  computed:{
    ...mapGetters(["host"]),
    dark(){
      return this.$store.state.config.dark
    },
    hasBanner(){
      return this.$route.meta.banner ? true : false
    },
    feauture(){
      let location = window.location.host.toString()
      let perma = (location.split(".")[1] == 'eetplein') ? location.split(".")[0] : null
      if (!perma && !location.includes('eetplein') &&  !location.includes('localhost')) perma = 'www'
      if (!location.includes(':') && perma && !['mijn', 'app', 'login'].includes(perma) ) return {
            index: "organisation/info",
            perma: perma,
            url: location
          }
      return null
    }
  },
  beforeCreate() {
    //if (!this.isNative) this.$OneSignal.showSlidedownPrompt()
  },
  async created() {
      this.setHost(null);
      if (this.feauture){
        let response = await this.$http.post("/api/host/info", this.feauture );
        this.setHost(response.data);
        this.loading = false
      }
  },
  mounted() {
    this.$root.$confirm = this.$refs.confirm.open
    this.$vuetify.theme.dark = this.dark
    var root = document.getElementsByTagName("html")[0];
    if (!this.isNative){
         // '0' to assign the first (and only `HTML` tag)
        //root.setAttribute("class", "web");
        root.classList.add("web");
    }
    root.classList.add("device-" + this.platform);
    root.setAttribute("device", this.platform);
    //window.addEventListener('focus', this.$events.$emit('APP-FOCUS'));
    window.onfocus = this.$events.$emit('APP-FOCUS')
    var self = this
    document.onvisibilitychange = function(event) { 
      if (document.visibilityState === "visible") {
            self.$events.$emit('APP-FOCUS')
      }else{
            self.$events.$emit('APP-BLUR')
      }
    };
  },
  methods: {
    ...mapActions(["setHost"]),
  }
};
</script>
<style>
@font-face {
  font-family: "Eetplein";
  src: url("assets/TechHeadlines-3Pzp.ttf"); 
}
@font-face {
  font-family: "Eetplein-sub";
  src: url("assets/BebasNeue-Regular.ttf"); 
}

.v-application--wrap {
  border: 0!important;
}
.eetplein-header{
  font-family: Eetplein;
  font-size: 1.25rem !important;
  line-height: 1.2;
  
}
.large .eetplein-header{
  font-size: 2rem !important;
  letter-spacing: 5px;
  letter-spacing: 5px;
}
.eetplein-subheader{
  font-family: Eetplein-sub;
  font-size: 1.1rem !important;
  
}

.main-content,
.main-content-bar .v-toolbar__content{
  max-width:1160px;
  margin:auto;
  justify-content: center;  
}
@media only screen and (min-width: 800px) {
 .main-content-bar .v-toolbar__content{
  max-width:1160px;
  padding-right:400px;
} 
}
.v-dialog.v-dialog--scrollable:not(.v-dialog--fullscreen){
  max-width:600px;
}
html.web,
html.web .v-input {
  font-size:17px!important;
}

html.device-ios .v-footer,
html.device-ios .v-bottom-navigation{
  padding-bottom: 20px;
  height: 70px;
}
html.device-ios header.v-app-bar{
  padding-top:33px!important;
}
html.device-ios header.v-app-bar:not(.collapsed):not(.extension) .v-toolbar__content{
  padding-bottom:33px!important;
}
html.device-ios header.v-app-bar.collapsed{
 height: 90px!important;
}

html.device-ios .v-application--wrap{
  margin-top:33px!important;
}
html.websssss .fixed-page-header{
    position: fixed;
    width: 100%;
    z-index: 100;
    top: 0;
}
.v-input.text-h6 input{
  font-size:1.2em;
}
.v-input.text-h6 .v-icon{
  font-size:2em;
  margin-right:10px
}
@media only screen and (min-width: 800px) {
  html.web body .v-application--wrap {
    border: 1px solid #e2e2e2;
  }
}
/*html.web .v-icon.v-icon {
  font-size: 32px;
}*/
html.web .v-card__subtitle, .v-card__text, .v-card__title {
    padding: 12px;
}
.v-card__title {
  word-break: break-word!important;
}
.v-application a {
    color: #0069b3;
    text-decoration: none;
}
.fill-page-height {
   height: auto!important;
    min-height: calc(100vh - 165px)!important;
    margin-bottom:100px!important;
}
.v-list-item.dense {
  min-height:auto;
}

main.v-main,
.app-background {
  background-color: #F8F9FA!important;
}
.v-application.theme--dark main.v-main,
.app-background.theme--dark {
  background-color: #808080!important;
}
.v-application .background {
    background: #F8F9FA !important;
    border-color: #F8F9FA !important;
}
.v-card.theme--dark.background,
.v-card--link.theme--dark
 {
      background-color: #2E2E2E !important;
    border-color: #2E2E2E !important;
}
.v-card.theme--dark .primary--text{
  color:#a8d6f4!important; /*#349DE2!important;*/
}
.primary--border {
  border-color: #a8d6f4!important
}
.card-list{
  border-left: thin solid rgba(0, 0, 0, 0.12)!important;
  border-right: thin solid rgba(0, 0, 0, 0.12)!important;
}
.v-footer.theme--light {
    border-top: thin solid rgba(0, 0, 0, 0.12)!important;
    border-color: rgba(0, 0, 0, 0.12)!important;
    background-color: #FFFFFF!important;
}
header.theme--light {
    border-bottom: thin solid rgba(0, 0, 0, 0.12)!important;
    border-color: rgba(0, 0, 0, 0.12)!important;
    background-color: #FFFFFF!important;
}
.theme--dark.v-chip--active:hover::before,
.theme--dark.v-chip--active::before {
  display: none;
}
.custom .v-parallax__image-container img{
  transform: translate(-50%, 0)!important;
  -webkit-transition: background-image 0.2s ease-in-out;
transition: background-image 0.2s ease-in-out;
}
.contain-image{
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  background-position: center;
}
.frosted-light{
   background-color: rgba(255, 255, 255, .25)!important;  
   backdrop-filter: blur(5px);
}
.toolbar-gradient{
  position:absolute;
  bottom:0!important;
  width:100%;
  padding-top:150px;
  background: linear-gradient(rgba(248,249,250,0),  rgba(248,249,250,1) 80%)!important;
}
.toolbar-main{
  position:absolute;
  bottom:0!important;
  width:100%;
  margin-top:150px;
}
.theme--dark .toolbar-gradient{
  background: linear-gradient(rgba(30,30,30,0), rgba(30,30,30,1) 80%)!important;
}
.toolbar-gradient .v-toolbar__content,
.v-parallax__content{
  padding:0!important;
}
.toolbar-gradient .v-toolbar{
  background:transparent!important;
  z-index:20;
}
.v-toolbar__extension,
.v-toolbar__extension .v-toolbar__content {
  padding:0px;
}
.v-parallax__content {
  color:inherit!important;
}
.v-parallax__image{
      transition: 0.3s opacity cubic-bezier(0.75, 0.8, 0.5, 1);
}
.app-btn{
  background:rgba(248,249,250,0.8)!important;
}
.theme--dark .app-btn{
  background:rgba(30,30,30,0.8)!important;
}
.v-list-item--link.no-select:before{
  background:0;
}
.v-list-item__action.align-content-start {
    -ms-flex-item-align: flex-start!important;
    align-self: flex-start!important;
}
.v-list.compact .v-list-item,
.v-list-item.dense {
    min-height: 48px!important;
    height: 48px!important;
}
.v-list.checklist .v-list-item {
    min-height: 36px!important;
    height: 36px!important;
}
.v-list.compact .v-list-item .v-list-item__icon,
 .v-list-item.dense .v-list-item__icon{
    margin: 10px 0;
}
.v-list.checklist .v-list-item__action,
.v-list.checklist .v-list-item__content{
  margin:0px;
  padding:0px;
}
.v-list-item__title, .v-list-item__subtitle {
    white-space: normal!important;
}
.theme--dark.v-otp-input .v-input .v-input__control .v-input__slot {
    background:transparent!important;
}
.v-otp-input.phone {
  max-width: 500px;
}
.v-otp-input.phone > .v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 40px!important;
    
}
.v-otp-input.phone .v-input {
    -ms-flex: 1 0 22px!important;
    flex: 1 0 22px!important;
}
.link{
  cursor:pointer;
}
 .do-wrap {
    white-space: normal!important;
  }
  .street-sign{
    background-color: #0069B3!important;
    text-transform: uppercase !important;
    border-radius: 8px !important;
    border: 2px solid white!important;
    /*box-shadow: 0 0 0 2pt #0069B3;*/
    -webkit-box-shadow: 0px 7px 8px -4px rgb(0 0 0 / 20%), 0px 13px 19px 2px rgb(0 0 0 / 14%), 0px 5px 24px 4px rgb(0 0 0 / 12%) !important;
    box-shadow: 0px 7px 8px -4px rgb(0 0 0 / 20%), 0px 13px 19px 2px rgb(0 0 0 / 14%), 0px 5px 24px 4px rgb(0 0 0 / 12%) !important;
    padding-top: 20px !important;
    padding-bottom: 20px !important;
    font-size: 1.25rem !important;
    font-weight: 500;
    line-height: 2rem;
    letter-spacing: 0.0325em !important;
    white-space: normal;
    
    }
</style>
